import React, { useState, useEffect } from "react";
import LoginView from "./view";
// @ts-ignore
import { useInput } from "react-hookedup";
import { Navigate } from "react-router-dom";
import { useLogin } from "../../mutationsQueries/user";
import { HOME_PAGE } from "../../util/constants";
import { UseMutationResult } from "react-query";

const LoginPage = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const email = useInput("");
  const password = useInput("");
  const {
    data,
    isSuccess,
    isError,
    mutate,
    error,
  }: UseMutationResult<any, any, { email: string; password: string }, unknown> =
    useLogin();

  useEffect(() => {
    if (isSuccess) {
      localStorage.setItem(
        "user",
        JSON.stringify({
          email: email.value,
          ...data,
        })
      );
    }
  }, [isSuccess, email.value, data]);

  useEffect(() => {
    if (isError && error?.response?.data?.error === "invalid_grant") {
      setErrorMessage(
        "Invalid credentials, please contact your administrator or IT provider to reset password"
      );
    } else if (isError && error?.response?.data?.error_description) {
      setErrorMessage(error.response.data.error_description);
    }
  }, [isError, error]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    mutate({ email: email.value, password: password.value });
  };

  if (isSuccess) return <Navigate to={HOME_PAGE} />;

  return (
    <LoginView
      email={email}
      errorMessage={errorMessage}
      password={password}
      onSubmit={onSubmit}
    />
  );
};

export default LoginPage;
